module.exports = __webpack_public_path__ + "static/img/9areaA_06.0475c59.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/9areaA_06.png
// module id = 1060
// module chunks = 1